var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.04 0H0.96C0.429 0 0 0.429 0 0.96V23.04C0 23.571 0.429 24 0.96 24H23.04C23.571 24 24 23.571 24 23.04V0.96C24 0.429 23.571 0 23.04 0ZM17.01 17.568C15.792 18.69 14.13 19.35 12.147 19.35C9.276 19.35 6.792 17.703 5.583 15.303C5.06787 14.2782 4.79972 13.147 4.8 12C4.8 10.812 5.085 9.69 5.583 8.697C6.792 6.294 9.276 4.647 12.147 4.647C14.127 4.647 15.789 5.376 17.064 6.561L14.958 8.67C14.196 7.941 13.227 7.572 12.15 7.572C10.236 7.572 8.616 8.865 8.037 10.602C7.89 11.043 7.806 11.514 7.806 12C7.806 12.486 7.89 12.957 8.037 13.398C8.616 15.135 10.236 16.428 12.147 16.428C13.137 16.428 13.977 16.167 14.634 15.726C15.414 15.204 15.93 14.427 16.101 13.506H12.147V10.662H19.068C19.155 11.145 19.2 11.646 19.2 12.165C19.2 14.406 18.399 16.287 17.01 17.568Z",
    fill: "#DB4A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.6a0fbf1cb5a13e6d0d538fdfefbbbd10.svg";
export { ForwardRef as ReactComponent };